import React from 'react';
import Text from '../../components/Text';
import { fontSizes } from '../../constants/constants';
import ViewReverse from '../../components/ViewReverse';
import ViewItems from '../../components/ViewItems';
import CustomInput from '../../components/CustomInput';
import CustomTextArea from '../../components/CustomTextArea';
import Button from '../../components/Button';
import contactFunctional from './index.function';
import { Formik } from 'formik';
import {
  contact_schema,
  contact_validation_schema,
} from '../../validations_schemas/contact_validation_schemas';
import ErrorText from '../../components/ErrorText';
import CustomDropdown from '../../components/CustomDropdown';
import { DocumentView } from './components';
import { requestTypes } from '../../config/config';
import { rowReverseStylesm } from '../../utils/styles';
import Divider from '../../components/Divider';
import { ReactSVG } from 'react-svg';
import icons from '../../constants/icons';
import { PhoneInput } from '../CorporateForm/components';

const Contact = () => {
  const {
    isArabic,
    TextWeight,
    settingLoading,
    getContentKey,
    onSubmit,
    image,
    setImage,
    navigate,
    clientDetails,
  } = contactFunctional();

  return (
    <div>
      <ViewReverse className='gap-5 items-center'>
        <ReactSVG
          src={icons?.backSmall}
          className={`cursor-pointer ${isArabic ? 'rotate-180' : ''}`}
          onClick={() => navigate(-1)}
        />
        <Text
          text={getContentKey('heading')}
          color='text-black'
          size={fontSizes.h18}
          weight={TextWeight.bold}
        />
      </ViewReverse>
      <div className='border border-grey rounded-xl mt-8 py-3 px-5 shadow-light'>
        <Formik
          enableReinitialize
          validationSchema={contact_validation_schema}
          initialValues={{
            ...contact_schema,
            name: clientDetails?.clientInformation?.clientName ?? "",
            email: clientDetails?.clientInformation?.clientEmail ?? "",
            phone: clientDetails?.clientInformation?.clientContact ?? "",
          }}
          onSubmit={(values, functions) =>
            onSubmit(values, functions?.resetForm)
          }
          validateOnBlur={false}
          validateOnChange={false}
        >
          {({ handleSubmit, setFieldValue, values, resetForm, errors }) => {
            const isValid =
              values?.name &&
              values?.email &&
              values?.phone &&
              values?.request_type &&
              values?.subject &&
              values?.description;

            return (
              <ViewItems className={'my-3'}>
                <Text
                  text={getContentKey('submit_support_ticket')}
                  weight={TextWeight.bold}
                  size={fontSizes.h18}
                />
                <ViewReverse
                  className={`w-full gap-4 my-5 flex-col ${rowReverseStylesm(
                    isArabic
                  )}`}
                >
                  <ViewItems className={'w-full'}>
                    <CustomInput
                      label={getContentKey('display_name')}
                      placeholder={getContentKey('display_name_placeholder')}
                      isRounded
                      isRequired
                      value={values?.name}
                      onChange={(e) => setFieldValue('name', e?.target?.value)}
                      isError={errors?.name}
                      isDisabled
                    />
                    <ErrorText
                      text={errors?.name}
                      getContentKey={getContentKey}
                    />
                  </ViewItems>

                  <ViewItems className={'w-full'}>
                    <CustomInput
                      label={getContentKey('email')}
                      placeholder={getContentKey('email_placeholder')}
                      isRounded
                      isRequired
                      value={values?.email}
                      onChange={(e) => setFieldValue('email', e?.target?.value)}
                      isError={errors?.email}
                      isDisabled
                    />
                    <ErrorText
                      text={errors?.email}
                      getContentKey={getContentKey}
                    />
                  </ViewItems>
                </ViewReverse>

                <ViewReverse
                  className={`w-full gap-4 mb-5 flex-col ${rowReverseStylesm(isArabic)}`}
                >
                  <ViewItems className={'w-full'}>
                    <PhoneInput
                      isRequired
                      label={getContentKey('phone_number')}
                      value={values?.phone}
                      onChange={(val) => {
                        setFieldValue('phone', val);
                      }}
                      isDisabled
                    />
                    <ErrorText
                      text={errors?.phone}
                      getContentKey={getContentKey}
                    />
                  </ViewItems>

                  <ViewItems className={'w-full'}>
                    <CustomDropdown
                      label={getContentKey('request_type')}
                      options={requestTypes(getContentKey)}
                      selectedValue={values?.request_type}
                      onSelect={(val) => {
                        setFieldValue('request_type', val);
                      }}
                      valueKey={'name'}
                      isError={errors?.request_type}
                      isRequired
                    />
                    <ErrorText
                      text={errors?.request_type}
                      getContentKey={getContentKey}
                    />
                  </ViewItems>
                </ViewReverse>
                <div className={'w-full mb-5'}>
                  <CustomInput
                    label={getContentKey('subject')}
                    placeholder={getContentKey('subject_placeholder')}
                    isRounded
                    isRequired
                    value={values?.subject}
                    onChange={(e) => setFieldValue('subject', e?.target?.value)}
                    isError={errors?.subject}
                  />
                  <ErrorText
                    text={errors?.subject}
                    getContentKey={getContentKey}
                  />
                </div>

                <div className={'w-full mb-5'}>
                  <CustomTextArea
                    label={getContentKey('description')}
                    isRounded
                    isRequired
                    rows={6}
                    value={values?.description}
                    onChange={(e) =>
                      setFieldValue('description', e?.target?.value)
                    }
                    isError={errors?.description}
                  />
                  <ErrorText
                    text={errors?.description}
                    getContentKey={getContentKey}
                  />
                </div>

                <ViewReverse className={'w-full'}>
                  <ViewItems className={'w-full md:w-1/2 my-2'}>
                    <DocumentView image={image} setImage={setImage} />
                  </ViewItems>
                </ViewReverse>

                <Divider className={'my-0'} />

                <ViewReverse className={'w-full gap-3'}>
                  <Button
                    text={getContentKey('submit')}
                    bgColor='bg-primary'
                    className={'w-36 text-center'}
                    onClick={handleSubmit}
                    isDisabled={!isValid}
                    loading={settingLoading}
                  />
                  <Button
                    text={getContentKey('reset')}
                    bgColor='bg-transparent'
                    color='text-primary'
                    className={'w-36 text-center border border-primary'}
                    onClick={() => {
                      resetForm();
                      setImage(null);
                    }}
                    isDisabled={settingLoading}
                  />
                </ViewReverse>
              </ViewItems>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default Contact;
